import { render, staticRenderFns } from "./BaseSelectorForm.vue?vue&type=template&id=2e2ad425&scoped=true&lang=pug"
import script from "./BaseSelectorForm.vue?vue&type=script&lang=ts"
export * from "./BaseSelectorForm.vue?vue&type=script&lang=ts"
import style0 from "./BaseSelectorForm.vue?vue&type=style&index=0&id=2e2ad425&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2ad425",
  null
  
)

export default component.exports